import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from '../../store/actions';
import { bindActionCreators } from 'redux';
import './how-to-buy.css';

export class HowToBuy extends Component {
    componentDidMount() {
        const { updateWording } = this.props;
        updateWording();
    }
    render() {
        const { wording } = this.props;
        return (
            <div>
                <div className="img-top-how-to-buy-contain">
                    <div className="img-top-how-to-buy" />
                </div>
                <div className="container contain-how-to-buy center">
                    <div className="title-paragraph-how-to-buy">
                        {wording.HowToBuyPage.title}
                    </div>

                    <div className='container mb-30'>
                        <div className='step-container'>
                            <div className='item-step' align='center'>
                                <div className='mb-20 item-text'>
                                    <div className='img-step background-img' style={{backgroundImage:'url(/assets/img/how-to-buy/selecthand.svg)',marginLeft:-13}}/>
                                    { wording.HowToBuyPage.select }
                                </div>
                                <div className='bullet-step' />
                            </div>
                            <div className='item-step' align='center'>
                                <div className='mb-20 item-text'>
                                    <div className='img-step background-img' style={{backgroundImage:'url(/assets/img/how-to-buy/Cart.svg)'}}/>
                                    { wording.HowToBuyPage.add }
                                </div>
                                <div className='bullet-step' />
                            </div>
                            <div className='item-step' align='center'>
                                <div className='mb-20 item-text'>
                                    <div className='img-step background-img' style={{backgroundImage:'url(/assets/img/how-to-buy/check.svg)'}}/>
                                    { wording.HowToBuyPage.check }
                                </div>
                                <div className='bullet-step' />
                            </div>
                            <div className='item-step' align='center'>
                                <div className='mb-20 item-text'>
                                    <div className='img-step background-img' style={{backgroundImage:'url(/assets/img/how-to-buy/payment.svg)'}}/>
                                    { wording.HowToBuyPage.payment }
                                </div>
                                <div className='bullet-step' />
                            </div>
                            <div className='item-step' align='center'>
                                <div className='mb-20 item-text'>
                                        <div className='img-step background-img' style={{backgroundImage:'url(/assets/img/how-to-buy/shiping.svg)'}}/>
                                        { wording.HowToBuyPage.shipping }
                                </div>
                                <div className='bullet-step' />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ language }) => ({
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(HowToBuy);
